var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"out-page"},[_vm._v(" 外部页面容器 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }